/* eslint-disable import/default */

import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore';
import Root from './app/Root';
import './favicon.ico';

const store = configureStore();

render(
  <Root
    store={ store }
  />,
  document.getElementById('app')
);
